
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "copyEmailTemplate",
      resolverType: "mutation",
      routePath: "/copyEmailTemplate",
      httpMethod: "POST",
    });
  